<template>
  <div
    class="d-flex align-items-center justify-content-center flex-column flex-grow-1 text-muted font-lg"
  >
    <div class="mt-5">
      <i :class="`icon-${icon}`" class="font-4xl" />
    </div>
    <div><slot /></div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "bubbles"
    }
  }
};
</script>
